import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/mapaRE/step1';
import { AvisInitialTypeLight } from '../models/AvisInitialTypeLight';
@Component({
  selector: 'app-avis-initial-type',
  templateUrl: './avis-initial-type.component.html'
})
export class AvisInitialTypeComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'AvisInitialType';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() avisInitial: AvisInitialTypeLight;

  public step1 = new Step1();

  public rg2 = 'CTRL_IDWEB';

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
	  return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

  getCtrl_idWebNames_json(): any {
    return { idWeb: "_SepSep_AttributionFromMAPA_SepSep_AvisInitialType_SepAtt_idWeb" };
  }
  
}

